export default __webpack_public_path__ + "static/corners-dont-276f1f66121657d2d920c8e08448021e4e3f05414832bfbd3ead0d9285c9fc0d.png";